import React from "react";

import cn from "classnames";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { UserRoute } from "../../routes";

import styles from "./styles.module.scss";

export interface DataDisclaimerProps {
  ttlDays: number;
  report: string;
  className?: string;
}

export const DataDisclaimer: React.FC<DataDisclaimerProps> = (props) => {
  const { className, ttlDays, report } = props;
  const { t } = useTranslation("data_disclaimer");

  return (
    <div className={cn(styles.container, className)}>
      <Trans ns="data_disclaimer" i18nKey="text" values={{ ttl: ttlDays }}>
        For this report we store data for <strong>TTL</strong> days, to request a longer time period fill out
      </Trans>
      <Link to={`${UserRoute.ExtendedReport}?report=${report}`}>
        <span className={styles.button}>{t("button")}</span>
      </Link>
    </div>
  );
};
